import { RadioGroup, Select } from '../../../itrust_common/components/form'
import { change, Field, formValueSelector } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { procedurePricingsLoad } from '../../../redux/actions/storeSettings/ProcedurePricingActions'

function TabAppointment(props) {
  const { staffs, tab_appointment, tabConfig, tabAddOnCred, tabMapperStatus, isNew, appointment, storeId, selectedStaffId } = props
  const [showTAB, setShowTAB] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    setShowTAB(((tabConfig?.status && tabConfig?.status !== 'inactive') && (tabAddOnCred?.status && tabAddOnCred?.status == 'success' && tabMapperStatus !== 'pending') && !tab_appointment))
  }, [])

  useEffect(() => {
    if (showTAB && !tab_appointment && isNew) {
      dispatch(change('appointmentForm', 'tab_appointment', true))
    }
  }, [showTAB])

  useEffect(() => {
    if (!storeId) return
    const params = {
      rpp: 99999,
      filter: { for_store: storeId },
      include: ['procedures'],
    }
    if (selectedStaffId) params.staff_id = selectedStaffId
    dispatch(procedurePricingsLoad(params))
  }, [dispatch, storeId, selectedStaffId])

  return (
    <div className='row mx-0 align-items-end mt-4'>
      {showTAB && <RadioGroup name="tab_appointment" options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]} wrapperClasses={`${showTAB ? 'col-4' : 'col-12'} form-group`} label="TAB Sync" />}
      <Field
        label="Provider"
        name="staff_id"
        component={Select}
        textField="name"
        valueField="id"
        data={[{ id: '', name: 'Select Provider' }, ...staffs]}
        wrapperClasses={`${showTAB ? 'col-8 pl-0' : 'col-12 px-5'} form-group`}
        supportAutoComplete={appointment.staff_attributes?.name}
        textFieldValue={appointment.staff_attributes?.name ? `${appointment.staff_attributes?.name} (Archived)` : ''}
      />
    </div>
  )
}

const selector = formValueSelector('appointmentForm')

const mapStateToProps = state => {
  const { organisation: { organisation }, tab, appointment: { appointment }, currentStore } = state
  return {
    tabConfig: organisation?.add_ons_config?.type?.tab,
    tabAddOnCred: tab.tab_add_on?.config?.creds,
    tabMapperStatus: tab.tabMapperStatus,
    appointment,
    storeId: currentStore.store?.id,
    selectedStaffId: selector(state, 'staff_id'),
  }
}

export default connect(mapStateToProps)(TabAppointment);
